<ml-status-message-popup-v2
  [popupInfo]="statusPopupElement"
  (closeEvent)="closeMessagePopup()"
></ml-status-message-popup-v2>
<div class="container">
  @if (isLoading()) {
    <ml-loader></ml-loader>
  }
  <pvmo-page id="page-edoc-documents"></pvmo-page>
</div>
